<template>
<div class="SpaceSearchTool" v-if="isShowSpaceTool">
  <span><Icon type="big" name="icon-Draw-circle" content="绘制圆" @click="onDrawCircle"></Icon></span>
  <span><Icon type="big" name="icon-Draw-polygon" content="绘制多边形" @click="onDrawPolygon"></Icon></span>
  <span><Icon type="big" name="icon-tuichu1" content="退出" @click="close"></Icon></span>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SpaceSearchTool',
  props: {},
  components: {},
  inject: ['refresh'],
  data () {
    return {
      params: {
        geoJson: {},
        mapId: 0,
        pageNumber: 1,
        pageSize: 20
      },
      showTool: true,
      entitiesList: []
    }
  },
  computed: {
    ...mapGetters(['isShowSpaceTool'])
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  beforeDestroy () {
    this.clearAllEntity()
  },
  methods: {
    clearAllEntity () {
      this.close()
      this.entitiesList.forEach(item => {
        this.$cesiumPlus.markerManager.removeMarkerById(item)
      })
      // 退出绘制状态
      this.$store.dispatch('setDrawState', false)
      this.$store.commit('SELECT_SPACESEARCHJEOJSON', null)
    },
    close () {
      // 恢复允许进入编辑状态
      this.$store.dispatch('setAllowDrawState', true)
      this.$store.commit('SELECT_ISSHOWSPACESEARCHDRAW', false)
      this.$store.dispatch('showLeft', true)
      this.$store.commit('SELECT_ISSHOWSPACETOOL', false)
      // 强制刷新当前路由
      this.refresh()
    },
    // 绘制关闭按钮
    createMeasureLabel (entity, position, text) {
      entity.position = position
      entity.label = new Cesium.LabelGraphics({
        text: text,
        font: '14px sans-serif',
        pixelOffset: new Cesium.Cartesian2(0, -50),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.HorizontalOrigin.CENTER,
        showBackground: false,
        fillColor: Cesium.Color.fromCssColorString('#FFFFFF'),
        outlineColor: Cesium.Color.fromCssColorString('#000000'),
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        heightReference: Cesium.HeightReference.NONE,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        outlineWidth: 30,
        show: true
      })
      entity.billboard = new Cesium.BillboardGraphics({
        image: require('@/assets/textures/close.png'),
        pixelOffset: new Cesium.Cartesian2(0, -10),
        heightReference: Cesium.HeightReference.NONE,
        disableDepthTestDistance: Number.POSITIVE_INFINITY
      })
    },
    // 绘制圆
    onDrawCircle () {
      this.$store.commit('SELECT_ISSHOWSPACETOOL', false)
      this.params.pageNumber = 1
      this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Circle, {
        clampMode: CesiumPlus.ClampMode.GroundAndModel,
        drawEndCall: (position, entity) => {
          this.entitiesList.push(entity.id)
          // 禁止在此进入编辑状态
          this.$store.dispatch('setAllowDrawState', false)
          if (entity) {
            const geoJson = this.$cesiumPlus.utils.entityExportGeoJson(entity)
            this.$store.commit('SELECT_SPACESEARCHJEOJSON', geoJson)
            this.createMeasureLabel(entity, position)
            this.$store.dispatch('showRight', true)
            // this.$emit('drawEndMsg', { type: this.$cesiumPlus.drawHandler.drawMode, entity: entity })
          }
        },
        escCall: () => {
          this.$store.commit('SELECT_ISSHOWSPACETOOL', true)
          setTimeout(() => {
            this.$store.dispatch('showLeft', false)
          })
        },
        styleList: [CesiumPlus.PolygonStyle.Measure()],
        properties: {
          labelAlwayShow: true,
          measureClose: true,
          sapceTool: true
        }
      })
    },
    // 绘制面
    onDrawPolygon () {
      this.$store.commit('SELECT_ISSHOWSPACETOOL', false)
      this.params.pageNumber = 1
      this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Polygon, {
        clampMode: CesiumPlus.ClampMode.GroundAndModel,
        drawEndCall: (position, entity) => {
          this.entitiesList.push(entity.id)
          this.$store.dispatch('setAllowDrawState', false)
          if (entity) {
            const geoJson = this.$cesiumPlus.utils.entityExportGeoJson(entity)
            this.$store.commit('SELECT_SPACESEARCHJEOJSON', geoJson)
            this.createMeasureLabel(entity, position[position.length - 1])
            this.$store.dispatch('showRight', true)
          }
        },
        escCall: () => {
          this.$store.commit('SELECT_ISSHOWSPACETOOL', true)
          setTimeout(() => {
            this.$store.dispatch('showLeft', false)
          })
        },
        styleList: [CesiumPlus.PolygonStyle.Measure()],
        properties: {
          labelAlwayShow: true,
          measureClose: true,
          sapceTool: true
        }
      })
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.SpaceSearchTool{
  width: 200px;
  height: 44px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid #53575B;
  box-shadow: 1px 4px 6px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  position: absolute;
  top: 70px;
  left: 50%;
  margin-left: -100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  >span{
    width: 68px;
    height: 30px;
    display: inline-block;
    transform: scale(0.9);
    &:nth-child(2){
      border-left: 1px solid rgba(255, 255, 255, 0.16);
      border-right: 1px solid rgba(255, 255, 255, 0.16);
    }
  }
}
</style>
